import { render, staticRenderFns } from "./OGxGeneralObservationPage.vue?vue&type=template&id=561cd52d"
import script from "./OGxGeneralObservationPage.vue?vue&type=script&lang=js"
export * from "./OGxGeneralObservationPage.vue?vue&type=script&lang=js"
import style0 from "./OGxGeneralObservationPage.vue?vue&type=style&index=0&id=561cd52d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports